module.exports = __webpack_public_path__ + "static/media/track-daytona.907cd421.png";


//////////////////
// WEBPACK FOOTER
// ./html/assets/images/track-daytona.png
// module id = 1030
// module chunks = 0